import { getRecipe, isVersionedObject, resolveRuleInheritance } from '../object-recipes.js';
/**
 * Clone a one object
 *
 * @param {T} obj
 * @returns {T}
 */
export function cloneOneObject(obj) {
    const recipe = getRecipe(obj.$type$);
    const result = {
        ...cloneObjectValue({ type: 'object', rules: recipe.rule }, obj, false),
        $type$: obj.$type$
    };
    return result;
}
/**
 * Clone a one id object
 *
 * @param {T} obj
 * @returns {T}
 */
export function cloneOneIdObject(obj) {
    const recipe = getRecipe(obj.$type$);
    return {
        ...cloneObjectValue({ type: 'object', rules: recipe.rule }, obj, false),
        $type$: obj.$type$
    };
}
export function cloneOneObjectFragment(recipeValue, value) {
    switch (recipeValue.type) {
        case 'string':
        case 'integer':
        case 'number':
        case 'boolean':
        case 'referenceToObj':
        case 'referenceToId':
        case 'referenceToClob':
        case 'referenceToBlob':
        case 'stringifiable':
            return value;
        case 'map':
            return cloneMapValue(recipeValue, value);
        case 'bag':
            return cloneBagValue(recipeValue, value);
        case 'array':
            return cloneArrayValue(recipeValue, value);
        case 'set':
            return cloneSetValue(recipeValue, value);
        case 'object':
            return cloneObjectValue(recipeValue, value, false);
    }
}
// ######## Private API ########
function cloneObjectValue(recipeValue, obj, idObject) {
    const result = {};
    for (const rawRule of recipeValue.rules) {
        const rule = resolveRuleInheritance(rawRule);
        const itemtype = rule.itemtype || { type: 'string' };
        if (idObject && rule.isId !== true) {
            continue;
        }
        if (obj[rule.itemprop] !== undefined) {
            result[rule.itemprop] = cloneOneObjectFragment(itemtype, obj[rule.itemprop]);
        }
    }
    return result;
}
function cloneMapValue(recipeValue, map) {
    const result = new Map();
    for (const [key, value] of map.entries()) {
        result.set(key, cloneOneObjectFragment(recipeValue.value, value));
    }
    return result;
}
function cloneBagValue(recipeValue, bag) {
    const result = [];
    for (const value of bag) {
        result.push(cloneOneObjectFragment(recipeValue.item, value));
    }
    return result;
}
function cloneArrayValue(recipeValue, array) {
    const result = [];
    for (const value of array) {
        result.push(cloneOneObjectFragment(recipeValue.item, value));
    }
    return result;
}
function cloneSetValue(recipeValue, set) {
    const result = new Set();
    for (const value of set) {
        result.add(cloneOneObjectFragment(recipeValue.item, value));
    }
    return result;
}
//# sourceMappingURL=clone-one-object.js.map